import { create } from "zustand";
export var useModal = create(function(set) {
    return {
        isOpen: false,
        returnValue: undefined,
        open: function() {
            return set({
                isOpen: true
            });
        },
        close: function() {
            return set({
                isOpen: false
            });
        },
        setReturnValue: function(returnValue) {
            return set({
                returnValue: returnValue
            });
        }
    };
});
